/** Only a leading, complete command token invokes a native conversation operation. */
export function parseConversationCommand(text: string) {
  const match = /^\/(goal|compact)(?:\s+([\s\S]*))?$/i.exec(text.trim());
  if (!match) return null;
  const argument = match[2]?.trim() ?? "";
  if (match[1]?.toLowerCase() === "compact") {
    return argument
      ? { type: "invalid" as const, error: "Use /compact without any additional text." }
      : { type: "compact" as const };
  }
  if (!argument) return { type: "invalid" as const, error: "Use /goal <objective>." };
  if (argument.length > 4000)
    return {
      type: "invalid" as const,
      error: "Keep the Goal objective to 4,000 characters or fewer.",
    };
  return { type: "goal" as const, objective: argument };
}

/** Whitespace-delimited command names share presentation in editable and rendered text. */
export function matchConversationCommand(text: string) {
  const match = /(^|\s)\/(goal|compact)(?=\s|$)/i.exec(text);
  if (!match) return null;
  const start = match.index + (match[1]?.length ?? 0);
  return { start, end: match.index + match[0].length };
}
